import { type PropsWithChildren } from 'react';

import type { BaseAnnotationsChartProps } from '../../../core/components/annotations/types/annotations.js';
import type { TextOverflowOptions } from '../../../core/components/annotations/types/marker.js';

/**
 * TimeseriesChart Annotations subcomponent props
 * @public
 */
export interface TimeseriesChartAnnotationsProps
  extends BaseAnnotationsChartProps {
  /**
   * How many tracks to show by default, if there are more tracks than the specified here a scrollbar will be added.
   * @defaultValue 3
   */
  visibleTracksLimit?: number;
  /**
   * Controls whether annotation text may expand beyond its track boundary or is truncated.
   * @defaultValue 'truncate'
   */
  textOverflow?: TextOverflowOptions;
}

/**
 * @public
 */
export const Annotations = (
  props: PropsWithChildren<TimeseriesChartAnnotationsProps>,
) => null;
